export const requestsStateEnum = [
  { id: 'WAITING_SUPERVISOR', label: 'čekající - přímy nadřízený' },
  { id: 'WAITING_ALL_SUPERVISORS', label: 'čekající - všichni nadřízení' },
  { id: 'TIME_OUT', label: 'vypršeno' },
  { id: 'SOLVED', label: 'vyřešeno' }
];

export const requestsResultEnum = [
  { id: 'PENDING', label: 'čekající' },
  { id: 'APPROVED', label: 'schváleno' },
  { id: 'DENIED', label: 'zamítnut' },
  { id: 'TIME_OUT_DENIED', label: 'vypršel limit - zamítnut' }
];



// WEBPACK FOOTER //
// ./src/modules/hr-requests/_requestsEnums.ts